
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ChatMessageAudioControlComponent extends Vue {
  @Prop({ default: 0 }) percentage!: number;

  isMouseDown = false;

  onMouseDown (ev: MouseEvent) {
    this.isMouseDown = true
    const seekPos = this.calculateLineHeadPosition(ev, this.$refs.progress)
    this.$emit('change-linehead', seekPos)
    document.addEventListener('mousemove', this.onMouseMove)
    document.addEventListener('mouseup', this.onMouseUp)
  }

  onMouseUp (ev: MouseEvent) {
    this.isMouseDown = false
    document.removeEventListener('mouseup', this.onMouseUp)
    document.removeEventListener('mousemove', this.onMouseMove)
    const seekPos = this.calculateLineHeadPosition(ev, this.$refs.progress)
    this.$emit('change-linehead', seekPos)
  }

  onMouseMove (ev: MouseEvent) {
    const seekPos = this.calculateLineHeadPosition(ev, this.$refs.progress)
    this.$emit('change-linehead', seekPos)
  }

  calculateLineHeadPosition (ev: MouseEvent, element: any) {
    const progressWidth = element.getBoundingClientRect().width
    const leftPosition = element.getBoundingClientRect().left
    let pos = (ev.clientX - leftPosition) / progressWidth

    pos = pos < 0 ? 0 : pos
    pos = pos > 1 ? 1 : pos

    return pos
  }
}
